package com.hyperether.goodjob.scenes.jobs

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredHeight
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Divider
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.BitmapPainter
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.navigation.NavHostController
import com.hyperether.goodjob.itemDetailsMargin
import com.hyperether.goodjob.itemDetailsMenuMargin
import com.hyperether.goodjob.log
import com.hyperether.goodjob.map.MapComponent
import com.hyperether.goodjob.models.CompletionReportStatus
import com.hyperether.goodjob.models.Contact
import com.hyperether.goodjob.models.Job
import com.hyperether.goodjob.models.JobStatus
import com.hyperether.goodjob.models.Note
import com.hyperether.goodjob.models.Step
import com.hyperether.goodjob.navigation.AddNewJob
import com.hyperether.goodjob.navigation.Jobs
import com.hyperether.goodjob.repository.Mapper
import com.hyperether.goodjob.repository.remote.model.CompletionReportResponse
import com.hyperether.goodjob.repository.remote.model.FileObject
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.about_job
import com.hyperether.goodjob.resources.completed
import com.hyperether.goodjob.resources.edit
import com.hyperether.goodjob.resources.files_notes
import com.hyperether.goodjob.resources.job_details
import com.hyperether.goodjob.resources.no_completion_report
import com.hyperether.goodjob.resources.no_tasks_text_employee
import com.hyperether.goodjob.resources.report_will_appear
import com.hyperether.goodjob.resources.steps
import com.hyperether.goodjob.resources.task_completion_report
import com.hyperether.goodjob.resources.task_empty
import com.hyperether.goodjob.scenes.addNew.StepInputFieldsWeb
import com.hyperether.goodjob.scenes.components.DetailsContainerJob
import com.hyperether.goodjob.scenes.components.DetailsLeftMenuItem
import com.hyperether.goodjob.scenes.components.WebViewHeaderWithRightContent
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.jobs.components.JobDetailsAssigneesViewWeb
import com.hyperether.goodjob.scenes.jobs.components.JobDetailsHeaderView
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.theme.DashboardBg
import com.hyperether.goodjob.theme.TextGrayColor
import com.hyperether.goodjob.util.Constants
import com.hyperether.goodjob.util.DocumentType
import com.hyperether.goodjob.util.StatusColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.goodjob.webDetailsTitle
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun JobDetailsWeb(
    isMobileView: Boolean,
    job: Job?,
    contact: Contact?,
    images: List<Pair<FileObject, BitmapPainter>>,
    documents: List<Pair<FileObject, String>>,
    navHostController: NavHostController,
    viewModel: JobDetailsViewModel,
    jobId: String,
    onOpenPdf: (String) -> Unit,
    onUploadDocumentClick: (String, DocumentType) -> Unit
) {

    log.d("JobDetailsWeb") { "JobDetailsWeb recompose. job: ${job?.id}" }
    var selectedIndex by remember { mutableStateOf(0) }

    val steps = remember { mutableStateListOf<Step?>() }
    job?.steps?.let {
        steps.clear()
        steps.addAll(it)
    }
    var submitFormShown by remember { mutableStateOf(false) }

    Box(
        modifier = Modifier.fillMaxSize().pointerInput(Unit) {
            detectTapGestures {
                // Same as onMenuClick
                if (viewModel.showNoteEditDeletePopUpMenu.value) {
                    viewModel.showNoteEditDeletePopUpMenu.value = false
                    viewModel.selectedNoteId.value = null
                }
            }
        }) {
        val scrollState = rememberScrollState()
        Column(
            modifier = Modifier.fillMaxSize().background(DashboardBg)
                .verticalScrollbar(scrollState)
                .verticalScroll(scrollState)
                .disableMouseDragScrollOnWeb()
        ) {
            WebViewHeaderWithRightContent(
                isBackAvailable = true,
                onBackClick = { navHostController.navigate(Jobs) },
                title = job?.jobTitle ?: ""
            ) {
                if (!viewModel.isEmployee()) {
                    Spacer(modifier = Modifier.width(8f.toScaleDp()))
                    Row(
                        modifier = Modifier
                            .clickableWithPointer {
                                if (job != null) {
                                    navHostController.navigate(AddNewJob(job?.id ?: ""))
                                }
                            },
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(
                            modifier = Modifier.size(24.toScaleDp()),
                            painter = painterResource(Res.drawable.edit),
                            contentDescription = "Edit job icon"
                        )
                        DisableSelection {
                            Text(
                                stringResource(Res.string.edit),
                                modifier = Modifier.padding(start = 8.toScaleDp()),
                                color = TextGrayColor,
                                fontSize = 18.toScaleSp(),
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }
                }
            }

            DetailsContainerJob {
                Column(modifier = Modifier.weight(1.2f)) {
                    Column(
                        modifier = Modifier
                            .width(280.toScaleDp())
                            .fillMaxHeight()
                            .padding(top = itemDetailsMenuMargin())
                    ) {
                        DetailsLeftMenuItem(
                            stringResource(Res.string.job_details),
                            selectedIndex == 0,
                            onSelected = { selectedIndex = 0 }
                        )
                        DetailsLeftMenuItem(
                            stringResource(Res.string.steps),
                            selectedIndex == 1,
                            onSelected = { selectedIndex = 1 }
                        )
                        DetailsLeftMenuItem(
                            stringResource(Res.string.files_notes),
                            selectedIndex == 2,
                            onSelected = { selectedIndex = 2 }
                        )
                        DetailsLeftMenuItem(
                            stringResource(Res.string.task_completion_report),
                            selectedIndex == 3,
                            onSelected = { selectedIndex = 3 }
                        )
                    }
                }
//                DetailsDivider()
                Divider(
                    modifier = Modifier
                        .width(1.toScaleDp())
                        .fillMaxHeight()
                        .requiredHeight(1150.toScaleDp())
                        .background(BorderColor)
                )
                Column(modifier = Modifier.fillMaxWidth().weight(5f)) {
                    Box(
                        modifier = Modifier.fillMaxSize()
                    ) {
                        if (selectedIndex == 0) {
                            viewModel.filesOpen.value = false
                            Column(
                                modifier = Modifier
                                    .fillMaxSize()
                                    .padding(itemDetailsMargin())
                            ) {
                                Row(
                                    verticalAlignment = Alignment.Top,
                                    modifier = Modifier.height(webDetailsTitle())
                                ) {
                                    Column {
                                        Text(
                                            fontSize = 27.toScaleSp(),
                                            fontWeight = FontWeight.Bold,
                                            text = stringResource(Res.string.about_job),
                                            maxLines = 1,
                                            overflow = TextOverflow.Ellipsis
                                        )

                                        Text(
                                            text = viewModel.site.value?.addressObject?.address
                                                ?: contact?.addressObject?.address ?: "",
                                            color = BlueApp,
                                            fontSize = 16.toScaleSp(),
                                            modifier = Modifier.padding(top = 24.toScaleDp()),
                                            maxLines = 1,
                                            overflow = TextOverflow.Ellipsis
                                        )
                                    }
                                }

                                // Job Title & Status
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .height(150.toScaleDp())
                                        .background(BorderColor)
                                ) {
                                    MapComponent(
                                        showMapWeb = mutableStateOf(true),
                                        showMap = true,
                                        markers = viewModel.getSiteMarkers(),
                                        currentPosition = mutableStateOf(
                                            viewModel.getSiteCurrentPosition()
                                        )
                                    )
                                }

                                Spacer(modifier = Modifier.height(25.toScaleDp()))
                                JobDetailsHeaderView(isMobileView, job, viewModel)
                                Spacer(modifier = Modifier.height(8.toScaleDp()))
                                JobDetailsAssigneesViewWeb(job)
                                Spacer(modifier = Modifier.height(8.toScaleDp()))

                                // Map Placeholder

                                job?.let { JobScheduleSection(it) }
                                Spacer(modifier = Modifier.height(16.toScaleDp()))
                                contact?.let { ContactDetailsSection(it) }
                            }
                        } else if (selectedIndex == 1) {
                            val markAsDoneEnabled = viewModel.isUserAssignedToJob(job)
                                    || viewModel.isAdmin()
                            viewModel.filesOpen.value = false
                            Column(modifier = Modifier) {
//                                        val steps = job?.steps.orEmpty().filterNotNull()
                                val totalSteps = steps.size
                                val completedSteps =
                                    steps.count { it?.stepStatus == Constants.STEP_STATUS_COMPLETED }
                                val percentCompleted =
                                    if (totalSteps > 0) (completedSteps * 100) / totalSteps else 0

                                val showAddTask = (!(job?.status == JobStatus.completed.name ||
                                        job?.status == JobStatus.pendingApproval.name) && !viewModel.isEmployee())
                                val showTaskPlaceholder =
                                    (!(job?.status == JobStatus.completed.name ||
                                            job?.status == JobStatus.pendingApproval.name) && viewModel.isEmployee())

                                if (steps.isNotEmpty()) {
                                    Column {
                                        Spacer(modifier = Modifier.height(24.toScaleDp()))
                                        Text(
                                            text = stringResource(Res.string.steps),
                                            color = Color.Black,
                                            fontWeight = FontWeight.W900,
                                            fontSize = 27.toScaleSp(),
                                            modifier = Modifier.padding(start = 16.toScaleDp()),
                                            maxLines = 1,
                                            overflow = TextOverflow.Ellipsis
                                        )
                                        Spacer(modifier = Modifier.height(16.toScaleDp()))
                                        Text(
                                            text = "${percentCompleted}% " + stringResource(
                                                Res.string.completed
                                            ),
                                            color = StatusColor.getStatusColor(job?.status),
                                            fontWeight = FontWeight.W900,
                                            fontSize = 16.toScaleSp(),
                                            modifier = Modifier.padding(start = 16.toScaleDp()),
                                            maxLines = 1,
                                            overflow = TextOverflow.Ellipsis
                                        )
                                        Spacer(modifier = Modifier.height(16.toScaleDp()))
                                        Column(
                                            modifier = Modifier.fillMaxSize()
                                        ) {
                                            if (steps.isNotEmpty()) {
                                                steps.filter { it?.stepTitle?.isNotEmpty() == true }
                                                    .forEachIndexed { index, step ->
                                                        step.let {
                                                            val stepCounter = remember {
                                                                mutableStateOf(
                                                                    index + 1
                                                                )
                                                            }
                                                            StepsItem(
                                                                isEmployee = viewModel.isEmployee(),
                                                                step = step!!,
                                                                markAsDoneEnabled = markAsDoneEnabled,
                                                                number = stepCounter,
                                                                onStepUpdateCallback = { stepState ->
                                                                    step.stepStatus = stepState
                                                                    viewModel.updateJobStepsStatus(
                                                                        jobId,
                                                                        steps = steps.filterNotNull(),
                                                                        onSuccess = {},
                                                                        onError = {})
                                                                },
                                                                onStepDeleteCallback = { step ->
                                                                    val updatedSteps =
                                                                        steps.filter { it != step }
                                                                    job?.id?.let {
                                                                        val jobRequest =
                                                                            Mapper().toJobUpdateRequest(
                                                                                job
                                                                            )
                                                                        jobRequest.steps =
                                                                            updatedSteps
                                                                        viewModel.updateJob(
                                                                            it,
                                                                            job = jobRequest,
                                                                            onSuccess = {},
                                                                            onError = {})
                                                                    }
                                                                })
                                                        }
                                                    }
                                            }
                                        }
                                        Column(
                                            modifier = Modifier.padding(
                                                start = 16.toScaleDp(),
                                                end = 16.toScaleDp(),
                                                top = 75.toScaleDp()
                                            ).fillMaxWidth(),
                                            horizontalAlignment = Alignment.CenterHorizontally
                                        ) {
                                            if (showAddTask) {
                                                StepInputFieldsWeb {
                                                    viewModel.addStepToJob(step = it)
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    Column(
                                        modifier = Modifier.padding(
                                            start = 16.toScaleDp(),
                                            end = 16.toScaleDp(),
                                            top = 75.toScaleDp()
                                        ).fillMaxWidth(),
                                        horizontalAlignment = Alignment.CenterHorizontally
                                    ) {
                                        if (showAddTask) {
                                            Spacer(modifier = Modifier.height(12.toScaleDp()))
                                            Text(
                                                text = stringResource(Res.string.task_empty),
                                                fontSize = 16.toScaleSp(),
                                                textAlign = TextAlign.Center
                                            )
                                            Spacer(modifier = Modifier.height(12.toScaleDp()))
                                            StepInputFieldsWeb {
                                                viewModel.addStepToJob(step = it)
                                            }
                                        } else if (showTaskPlaceholder) {
                                            Spacer(modifier = Modifier.height(12.toScaleDp()))
                                            Text(
                                                text = stringResource(Res.string.no_tasks_text_employee),
                                                fontSize = 16.toScaleSp(),
                                                textAlign = TextAlign.Center
                                            )
                                            Spacer(modifier = Modifier.height(12.toScaleDp()))
                                        }
                                    }
                                }
                                Spacer(modifier = Modifier.height(20.toScaleDp()))
                            }
                        } else if (selectedIndex == 2) {
                            log.d("JobDetailsWeb") { "JobDetailsWeb recompose. documents: ${documents.size} notes:${job?.noteObjects?.size}" }
                            viewModel.filesOpen.value = true
                            job?.let {
                                NotesAndDocumentsView(
                                    isWebView = true,
                                    images = images,
                                    documents = documents,
                                    job = it,
                                    isEmployee = viewModel.isEmployee(),
                                    onAddNoteClick = {
                                        viewModel.showNotePopUp.value = true
                                    },
                                    onOpenPdfClick = { fileId ->
                                        onOpenPdf(fileId)
                                    },
                                    onDeleteFileClick = { fileId ->
                                        viewModel.selectedFileId.value = fileId
                                        viewModel.selectedJob.value = it
                                        viewModel.showAreYouSurePopUpDeleteFile.value = true
                                    },
                                    onDeleteImageClick = { imageName ->
                                        viewModel.selectedImageFileId.value = imageName
                                        viewModel.selectedJob.value = it
                                        viewModel.showAreYouSurePopUpDeleteImage.value = true
                                    },
                                    onMenuClicked = { note: Note ->
                                        if (viewModel.selectedNoteId.value == note._id && viewModel.showNoteEditDeletePopUpMenu.value) {
                                            viewModel.showNoteEditDeletePopUpMenu.value = false
                                            viewModel.selectedNoteId.value = null
                                        } else {
                                            viewModel.selectedNoteId.value = note._id
                                            viewModel.noteToEditOrDelete.value = note
                                            viewModel.showNoteEditDeletePopUpMenu.value = true
                                        }
                                    },
                                    onEditNote = { note ->
                                        viewModel.noteInput.value = note.noteText.orEmpty()
                                        viewModel.showNotePopUp.value = true
                                        viewModel.isEditSelectedNote.value = true
                                        viewModel.selectedNoteId.value = note._id
                                    },
                                    onDeleteNote = {
                                        viewModel.showAreYouSurePopUpDeleteNote.value = true
                                        viewModel.selectedNoteId.value = null
                                    },
                                    isPopupVisible = { note ->
                                        viewModel.selectedNoteId.value == note._id && viewModel.showNoteEditDeletePopUpMenu.value
                                    },
                                    onAddFileClick = { jobId ->
                                        onUploadDocumentClick(jobId, DocumentType.JOB_FILE)
                                    },
                                    onOpenImageClick = { painter ->
                                        viewModel.onOpenImageClick(painter)
                                    })
                            }
                        } else if (selectedIndex == 3) {
                            viewModel.filesOpen.value = false
                            var report: CompletionReportResponse? = null
                            job?.completionReport?.let {
                                report = Mapper().jsonAsObject<CompletionReportResponse>(
                                    job?.completionReport
                                )
                            }
                            if (report == null && !submitFormShown) {
                                Column(
                                    modifier = Modifier.padding(
                                        start = 16.toScaleDp(),
                                        end = 16.toScaleDp(),
                                        top = 75.toScaleDp()
                                    ).fillMaxWidth(),
                                    horizontalAlignment = Alignment.CenterHorizontally
                                ) {
                                    Text(
                                        text = stringResource(Res.string.no_completion_report),
                                        fontSize = 24.toScaleSp(),
                                        color = Color.Black,
                                        fontWeight = FontWeight.Bold,
                                        textAlign = TextAlign.Center

                                    )
                                    Spacer(modifier = Modifier.height(15.toScaleDp()))
                                    Text(
                                        text = stringResource(Res.string.report_will_appear),
                                        fontSize = 16.toScaleSp(),
                                        textAlign = TextAlign.Center
                                    )
                                }
                            }
                            if (viewModel.isUserAssignedToJob(job)) {
                                log.d("XXX") {
                                    "isUserAssignedToJob: ${
                                        viewModel.isUserAssignedToJob(
                                            job
                                        )
                                    }"
                                }
                                job?.let {
                                    log.d("XXX") { "report: $report" }

                                    if (report == null || report?.status == CompletionReportStatus.rejected.name) {
                                        log.d("XXX") { "report: ${report}, reporrt status: ${report?.status}" }

                                        if (report != null) {
                                            viewModel.damageState.value = report?.damage == true
                                            viewModel.damageTextState.value =
                                                report?.damageDescription ?: ""
                                            viewModel.healthAndSafetyState.value =
                                                report?.healthAndSafety == true
                                            viewModel.healthAndSafetyTextState.value =
                                                report?.unmetSafetyRequirements ?: ""
                                            viewModel.correctFunctionalityState.value =
                                                report?.correctFunctionality == true
                                            viewModel.correctFunctionalityTextState.value =
                                                report?.reasonForIncompleteInspection ?: ""
                                            viewModel.additionalNotesText.value =
                                                report?.additionalNotes ?: ""
                                            viewModel.clientFeedbackText.value =
                                                report?.clientFeedback ?: ""
                                            viewModel.filesList.clear()
                                            report?.files?.let {
                                                viewModel.filesList.addAll(it)
                                            }
                                        }
                                        submitFormShown = true
                                        CompletionReportSubmit(
                                            viewModel,
                                            navHostController,
                                            job!!,
                                            report,
                                            onUploadDocumentClick
                                        )
                                    } else {
                                        log.d("XXX") { " ELSE; report: ${report}, reporrt status: ${report?.status}" }
                                        CompletionReportOverview(
                                            viewModel, navHostController, job!!, report, onOpenPdf
                                        )
                                    }
                                }
                            } else {
                                log.d("XXX") {
                                    "isUserAssignedToJob: ${
                                        viewModel.isUserAssignedToJob(
                                            job
                                        )
                                    }"
                                }
                                job?.let {
                                    CompletionReportOverview(
                                        viewModel, navHostController, it, report, onOpenPdf
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
        if (viewModel.showPreviewImage.value) {
            viewModel.previewImageFile.value?.let {
                DisableSelection {
                    FullScreenImagePreview(
                        imagePainter = it, onDismiss = {
                            viewModel.showPreviewImage.value = false
                            viewModel.previewImageFile.value = null
                        })
                }
            }
        }
    }
}